// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const SuperscriptTag: MarkdocTagRegistration = {
  tag: 'sup',
  component: 'Superscript',
};
